/* assets/quiz.js — generieke, data-driven quiz (typologie-model).
   Config komt uit de WMS via Edge Function quiz-config?slug=<slug>.
   Knoppen met [data-quiz="<slug>"] openen de globale modal en starten de quiz.
   Scoremodel: per dimensie 'direct' (gekozen uitkomst) of 'score' (hoogste som
   punten wint, tiebreak-uitkomst bij gelijkstand).
   Resultaat: mode 'combo' (default) = match op config.results; mode 'filter_score'
   = filter op role=filter, score op role=score, top_n packages (WMS sept 2026). */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(val || '').trim());
  }

  var CSS = [
    '.quiz-modal{position:fixed;inset:0;z-index:99999;display:none;align-items:flex-start;justify-content:center;padding:5vh 1rem;background:rgba(0,0,0,.55);overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.quiz-modal.is-open{display:flex}',
    '.quiz-modal__dialog{position:relative;background:var(--COLOR-BG);color:var(--COLOR-TEXT);max-width:640px;width:100%;border:1px solid var(--COLOR-BORDER);border-radius:8px;padding:2.5rem 2.75rem 2.25rem;box-shadow:0 16px 40px rgba(0,0,0,.18)}',
    '.quiz-inline{color:var(--COLOR-TEXT);max-width:680px;margin:0 auto;background:var(--COLOR-BG-BRIGHTER);border:1px solid var(--COLOR-BORDER);border-radius:8px;padding:1.75rem 1.75rem 1.5rem}',
    '.quiz-inline--split{max-width:none;margin:0;padding:0;border:none;border-radius:0;background:transparent;box-shadow:none}',
    '.quiz-inline--split .quiz__head{text-align:left}',
    '.quiz-modal__close{position:absolute;top:.5rem;right:.5rem;width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;background:none;border:none;font-size:1.6rem;line-height:1;cursor:pointer;color:var(--COLOR-TEXT-LIGHT)}',
    '.quiz-modal__close:hover{color:var(--COLOR-TEXT)}',
    '.quiz__head{text-align:center;margin-bottom:1.4rem}',
    '.quiz__subheading{text-transform:uppercase;letter-spacing:.14em;font-size:var(--font-body-small);color:var(--BTN-PRIMARY-BG);font-weight:600;margin:0 0 .5rem}',
    '.quiz__heading{font-family:var(--FONT-STACK-HEADING);font-weight:var(--FONT-WEIGHT-HEADING);color:var(--COLOR-TEXT);font-size:30px;line-height:1.15;margin:0}',
    '.quiz__lead{margin:.65rem 0 0;max-width:56ch;color:var(--COLOR-TEXT-LIGHT);line-height:1.55;font-size:var(--font-body-small)}',
    '.quiz__progress{margin-bottom:1rem}',
    '.quiz__progress-track{height:3px;background:var(--COLOR-BORDER);border-radius:0;overflow:hidden;margin:0 0 .65rem}',
    '.quiz__progress-bar{height:100%;width:0;background:var(--COLOR-TEXT);border-radius:0;transition:width .25s ease}',
    '.quiz__progress-text{display:block;text-transform:uppercase;letter-spacing:.09em;font-size:11px;color:var(--COLOR-TEXT-LIGHT);margin:0 0 .65rem}',
    '.quiz__q-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;color:var(--COLOR-TEXT);font-size:21px;line-height:1.25;margin:0 0 .4rem}',
    '.quiz__q-help{color:var(--COLOR-TEXT-LIGHT);font-size:var(--font-body-small);margin:0 0 1rem;line-height:1.5}',
    '.quiz__options{display:flex;flex-direction:column;gap:9px}',
    '.quiz__option{display:flex;align-items:center;gap:14px;width:100%;text-align:left;padding:12px 18px;border:1px solid var(--COLOR-BORDER);border-radius:6px;background:var(--COLOR-BG);color:var(--COLOR-TEXT);font-size:var(--font-body);cursor:pointer;transition:border-color .15s,background .15s}',
    '.quiz__option:hover{border-color:var(--COLOR-TEXT)},.quiz__option.is-pressed{border-color:var(--COLOR-TEXT);background:var(--COLOR-BG-ACCENT,var(--COLOR-BG-BRIGHTER))}',
    '.quiz__option svg{width:16px;height:16px;flex:0 0 auto;color:var(--BTN-PRIMARY-BG)}',
    '.quiz__back{display:inline-flex;align-items:center;gap:.35rem;margin:0 0 .75rem;background:none;border:none;color:var(--COLOR-TEXT-LIGHT);cursor:pointer;font-size:var(--font-body-small);padding:0}',
    '.quiz__back:hover{color:var(--COLOR-TEXT)}',
    '.quiz__back svg{width:14px;height:14px;flex:none}',
    '.quiz__pd-back{margin:0 0 1.25rem;display:inline-flex;align-items:center;gap:.4rem;font-size:var(--font-body-large);font-weight:600;color:var(--BTN-PRIMARY-BG);padding:.5rem .9rem;border:1px solid var(--COLOR-BORDER);border-radius:6px}',
    '.quiz__pd-back:hover{color:var(--BTN-PRIMARY-TEXT);background:var(--BTN-PRIMARY-BG);border-color:var(--BTN-PRIMARY-BG)}',
    '.quiz__result-eyebrow{text-transform:uppercase;letter-spacing:.14em;font-size:var(--font-body-small);color:var(--BTN-PRIMARY-BG);font-weight:600;margin:0 0 .4rem}',
    '.quiz__result-title{font-family:var(--FONT-STACK-HEADING);font-weight:var(--FONT-WEIGHT-HEADING);color:var(--COLOR-TEXT);font-size:26px;line-height:1.2;margin:0 0 1rem}',
    '.quiz__result-text{margin:0 0 1rem;line-height:1.55}',
    '.quiz__items-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;color:var(--COLOR-TEXT);font-size:19px;margin:1.5rem 0 .75rem}',
    '.quiz__items{list-style:none;margin:0 0 1.5rem;padding:0;columns:2;column-gap:1.5rem}',
    '.quiz__items li{padding:.4rem 0;border-bottom:1px solid var(--COLOR-BORDER-LIGHT);break-inside:avoid}',
    '.quiz__disclaimer{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:0 0 1.5rem}',
    '.quiz__restart{cursor:pointer}',
    '',
    '.quiz__capture{border-top:1px solid var(--COLOR-BORDER-LIGHT);margin:1.5rem 0;padding-top:1.5rem}',
    '.quiz__capture-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;color:var(--COLOR-TEXT);font-size:18px;margin:0 0 .85rem}',
    '.quiz__capture-form{display:flex;flex-direction:column;gap:.7rem}',
    '.quiz__email{padding:.8rem 1rem;border:1px solid var(--COLOR-BORDER);border-radius:6px;background:var(--COLOR-BG-BRIGHTER);color:var(--COLOR-TEXT);font-size:var(--font-body);font-family:inherit;width:100%}',
    '.quiz__email:focus{outline:none;border-color:var(--BTN-PRIMARY-BG)}',
    '.quiz__nl-label{display:flex;align-items:flex-start;gap:.5rem;font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);cursor:pointer;line-height:1.4}',
    '.quiz__nl-label input{margin:.15rem 0 0;flex:none}',
    '.quiz__send{align-self:flex-start;border-radius:6px;cursor:pointer}',
    '.quiz__capture-msg{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:0;min-height:1em}',
    '.quiz__capture-msg.is-error{color:var(--COLOR-ERROR)}',
    '.quiz__email.is-invalid{border-color:var(--COLOR-ERROR)}',
    '.quiz__nl-label.is-invalid{color:var(--COLOR-ERROR)}',
    '.quiz__capture--gate{border-top:none;margin:0 0 1.25rem;padding-top:0}',
    '.quiz__capture-done{font-size:var(--font-body);color:var(--COLOR-TEXT);margin:0 0 1.5rem}',
    '.quiz__loading{padding:1rem 0;color:var(--COLOR-TEXT-LIGHT);font-size:var(--font-body-small)}',
    // 2-koloms layout met productpaneel
    // productkaarten in het resultaat
    '.quiz__pcards{display:grid;grid-template-columns:repeat(auto-fill,minmax(132px,1fr));gap:.75rem;margin:0 0 1.5rem}',
    // Ranked filter_score: #1 featured full-width; #2/#3 under secondary heading
    '.quiz__pcards--primary{grid-template-columns:1fr;gap:1rem;margin:0 0 1.5rem}',
    '.quiz__pcards--ranked{grid-template-columns:1fr 1fr;gap:1rem}',
    '.quiz__pcards--ranked.quiz__pcards--secondary-single{grid-template-columns:1fr;max-width:320px}',
    '.quiz__result-secondary{margin:0 0 1.5rem}',
    '.quiz__result-secondary .quiz__items-title{margin:0 0 1rem}',
    '.quiz__result-secondary .quiz__pcards{margin:0}',
    '.quiz__pcard-wrap--rank1{grid-column:1/-1}',
    '.quiz__pcard--rank1{flex-direction:row;align-items:stretch;text-align:left}',
    '.quiz__pcard--rank1 img{width:42%;max-width:280px;aspect-ratio:4/3;flex:none}',
    '.quiz__pcard--rank1 .quiz__pcard-body{display:flex;flex-direction:column;justify-content:center;padding:.85rem 1rem;gap:.35rem;flex:1;min-width:0}',
    '.quiz__pcard--rank1 .quiz__pcard-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;font-size:18px;line-height:1.25;padding:0}',
    '.quiz__pcard--rank1 .quiz__pcard-note{font-size:var(--font-body-small);padding:0;line-height:1.45;opacity:.85}',
    '.quiz__pcard-badge{display:inline-block;align-self:flex-start;text-transform:uppercase;letter-spacing:.12em;font-size:11px;font-weight:600;color:var(--BTN-PRIMARY-TEXT);background:var(--BTN-PRIMARY-BG);padding:.3rem .55rem;border-radius:4px;margin:0}',
    '.quiz__pcard-rank{display:inline-block;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--COLOR-TEXT-LIGHT);padding:.5rem .6rem 0}',
    '.quiz__promo{margin:0 0 1.5rem;padding:1.15rem 1.25rem;border:1px solid var(--COLOR-BORDER);border-radius:8px;background:var(--COLOR-BG-BRIGHTER)}',
    '.quiz__promo-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;color:var(--COLOR-TEXT);font-size:18px;margin:0 0 .35rem}',
    '.quiz__promo-sub{color:var(--COLOR-TEXT-LIGHT);font-weight:400;font-size:var(--font-body-small);margin:.5rem 0 0}',
    '.quiz__promo-body{color:var(--COLOR-TEXT-LIGHT);font-size:var(--font-body-small);line-height:1.5;font-weight:600;margin:0}',
    '.quiz__promo-body p{margin:0 0 .5rem;font-weight:600}.quiz__promo-body p:last-child{margin-bottom:0}.quiz__promo-body a{color:inherit;text-decoration:underline}',
    '.quiz__promo-cta{margin-top:.85rem}',
    '@media (max-width:600px){.quiz__pcards--ranked{grid-template-columns:1fr}.quiz__pcard--rank1{flex-direction:column}.quiz__pcard--rank1 img{width:100%;max-width:none}}',
    // Klaviyo favorieten-knop: Klaviyo injecteert een eigen position:absolute knop (top:8px/right:12px)
    // die zich t.o.v. de dichtstbijzijnde positioned ancestor plaatst. We maken daarom de wrap relative
    // en laten de slot zelf ongepositioneerd — identiek aan snippets/product-grid-item.liquid op de PLP.
    '.quiz__pcard-wrap{position:relative}',
    '.quiz__pcard{display:flex;flex-direction:column;text-align:left;width:100%;border:1px solid var(--COLOR-BORDER);border-radius:8px;overflow:hidden;background:var(--COLOR-BG-BRIGHTER);cursor:pointer;padding:0;transition:border-color .15s}',
    '.quiz__pcard:hover{border-color:var(--BTN-PRIMARY-BG)}',
    '.quiz__pcard img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block;background:var(--COLOR-BG-ACCENT)}',
    '.quiz__pcard-title{font-size:13px;line-height:1.3;padding:.5rem .6rem .25rem;color:var(--COLOR-TEXT)}',
    '.quiz__pcard-note{font-size:11px;line-height:1.4;padding:0 .6rem .55rem;color:var(--COLOR-TEXT-LIGHT);opacity:.8}',
    // product-detailweergave (vervangt de plantenlijst bij klik)
    '.quiz__pd{max-width:520px}',
    '.quiz__pd-imgwrap{position:relative;display:inline-block;max-width:340px;width:100%;margin-bottom:1rem}',
    '.quiz__pd-img{width:100%;max-width:340px;aspect-ratio:1/1;object-fit:cover;border-radius:8px;background:var(--COLOR-BG-ACCENT);display:block}',
    '.quiz__pd-title{font-family:var(--FONT-STACK-HEADING);font-weight:600;color:var(--COLOR-TEXT);font-size:24px;line-height:1.2;margin:0 0 .35rem}',
    '.quiz__pd-price{color:var(--BTN-PRIMARY-BG);font-weight:600;font-size:18px;margin:0 0 1rem}',
    '.quiz__pd-desc{margin:1.25rem 0;line-height:1.6;font-size:var(--font-body)}',
    '.quiz__pd-extra{margin-top:.5rem}',
    '.quiz__pv-variants{display:flex;flex-wrap:wrap;gap:.4rem;margin:0 0 .9rem}',
    '.quiz__pv-variant{border:1px solid var(--COLOR-BORDER);border-radius:6px;padding:.4rem .7rem;font-size:13px;cursor:pointer;background:var(--COLOR-BG)}',
    '.quiz__pv-variant.is-active{border-color:var(--BTN-PRIMARY-BG);background:var(--BTN-PRIMARY-BG);color:var(--BTN-PRIMARY-TEXT)}',
    '.quiz__pv-variant:disabled{opacity:.4;cursor:not-allowed}',
    '.quiz__pv-add{border-radius:6px;cursor:pointer}',
    '.quiz__pv-add.is-added{background:var(--COLOR-SUCCESS,#56AD6A);border-color:var(--COLOR-SUCCESS,#56AD6A);color:#fff}',
    '.quiz__pv-msg{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:.5rem 0 0}',
    '@media (max-width:600px){.quiz-modal{padding:0}.quiz-modal__dialog{padding:2rem 1.25rem;min-height:100%;border-radius:0}.quiz__heading{font-size:25px}.quiz__q-title{font-size:19px}.quiz__items{columns:1}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('quiz-styles')) return;
    var st = document.createElement('style');
    st.id = 'quiz-styles';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  // ---- modal-host + globale state ----
  var modal, dialog, configEndpoint, submitEndpoint, anonKey;
  var cache = {};            // slug -> config
  var customerEmail = '';
  var triggersBound = false;

  function getModal() {
    if (modal) return modal;
    modal = document.querySelector('.quiz-modal');
    if (!modal) return null;
    dialog = modal.querySelector('.quiz-modal__dialog');
    configEndpoint = modal.dataset.configEndpoint || '';
    submitEndpoint = modal.dataset.submitEndpoint || '';
    anonKey = modal.dataset.key || '';
    customerEmail = modal.dataset.email || '';
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.quiz-modal__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    return modal;
  }

  function open() {
    getModal();
    if (!modal) return;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function authHeaders() {
    return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + anonKey, 'apikey': anonKey };
  }

  function loadConfig(slug) {
    if (cache[slug]) return Promise.resolve(cache[slug]);
    return fetch(configEndpoint + '?slug=' + encodeURIComponent(slug), { headers: authHeaders() })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) { cache[slug] = d; return d; });
  }

  // ---- quiz-run per slug ----
  function runQuiz(slug, source, opts) {
    opts = opts || {};
    dialog.innerHTML = '<button type="button" class="quiz-modal__close" aria-label="Sluiten">&times;</button>' +
      '<p class="quiz__loading">Even laden…</p>';
    loadConfig(slug).then(function (d) {
      startQuiz(slug, d.config || {}, source, opts);
    }).catch(function () {
      dialog.querySelector('.quiz__loading').textContent = 'De test kon niet geladen worden. Probeer het later opnieuw.';
    });
  }

  // Beervelde-promo: standaardteksten = de oorspronkelijke hardcoded copy.
  // Overschreven door data-promo-* op de host (sectie-instellingen). Attribuut aanwezig
  // maar leeg = dat stuk niet tonen. Geen attribuut (bv. modal) = standaardtekst.
  var PROMO_DEFAULTS = {
    title: '5% korting op je borderpakket',
    period: 'Geldig van vrijdag 9 tot en met zondag 18 oktober',
    body: 'De kortingsactie volgt nog. Dit is de aankondiging; een code of checkout-korting komt later.'
  };
  function readPromo(host) {
    var ds = (host && host.dataset) || {};
    function pick(key, def) { return typeof ds[key] === 'string' ? ds[key].trim() : (def || ''); }
    var bodyHtml = typeof ds.promoBody === 'string' ? ds.promoBody.trim() : null;
    return {
      title: pick('promoTitle', PROMO_DEFAULTS.title),
      period: pick('promoPeriod', PROMO_DEFAULTS.period),
      bodyHtml: bodyHtml,
      body: bodyHtml === null ? PROMO_DEFAULTS.body : '',
      btnLabel: pick('promoButtonLabel', ''),
      btnUrl: pick('promoButtonUrl', '')
    };
  }

  function startQuiz(slug, config, source, opts) {
    opts = opts || {};
    var host = opts.host || dialog;          // render-container: modal-dialog of inline-element
    var isModal = opts.modal !== false;       // default modal (bestaand gedrag)
    var optEmail = opts.email || customerEmail;
    var optLoggedIn = !!opts.loggedIn;
    var showPromo = !!opts.showPromo;         // section/theme: Beervelde promo-blok onder resultaat
    // Alleen als de sectie het vraagt (Beervelde-pagina): resultaat verborgen tot e-mail + nieuwsbrief.
    var gateResults = !!opts.gateResults;
    var capturedEmail = '';
    var pres = config.presentation || {};
    if (pres.show_beervelde_promo === true) showPromo = true;
    var dims = config.dimensions || [];
    var questions = config.questions || [];
    var results = config.results || [];
    var state = { step: 0, scores: {}, direct: {} };

    var splitParent = !isModal && host.closest && host.closest('[data-quiz-split]');
    host.className = (isModal ? 'quiz-modal__dialog' : 'quiz-inline') + (splitParent ? ' quiz-inline--split' : '') + (pres.color_scheme ? ' color-' + pres.color_scheme : '');

    var html = isModal ? '<button type="button" class="quiz-modal__close" aria-label="Sluiten">&times;</button>' : '';
    // Split-pagina toont eyebrow/titel/lead + Start-CTA al in Liquid (data-quiz-split-intro).
    // Die verdwijnt bij start; hier geen tweede kop uit WMS presentation tekenen.
    if (!splitParent && (pres.subheading || pres.heading || pres.intro_text)) {
      html += '<div class="quiz__head">';
      if (pres.subheading) html += '<p class="quiz__subheading">' + esc(pres.subheading) + '</p>';
      if (pres.heading) html += '<h2 class="quiz__heading">' + esc(pres.heading) + '</h2>';
      if (pres.intro_text) html += '<p class="quiz__lead">' + esc(pres.intro_text) + '</p>';
      html += '</div>';
    }
    html += '<div class="quiz__progress" role="progressbar" aria-valuemin="1" aria-valuemax="' + questions.length + '" aria-valuenow="1">' +
      '<div class="quiz__progress-track"><div class="quiz__progress-bar"></div></div>' +
      '<p class="quiz__progress-text"></p></div>' +
      '<div class="quiz__stage" aria-live="polite"></div>';
    host.innerHTML = html;
    if (isModal) { var closeBtn = host.querySelector('.quiz-modal__close'); if (closeBtn) closeBtn.addEventListener('click', close); }
    var stageEl = host.querySelector('.quiz__stage');

    function money(cents) {
      try { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); } catch (e) { return ''; }
    }

    // ---- Klaviyo favorieten ----
    // Productdata wordt gecachet zodat de favoriet-knop op de resultaatkaarten en de
    // detailweergave dezelfde fetch delen. De slot-div is identiek aan die in het theme
    // (snippets/product-grid-item.liquid); Klaviyo's onsite-script vult dynamisch
    // toegevoegde slots vanzelf op via een DOM-observer, dus geen re-init nodig.
    var productCache = {};
    function loadProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (p) { productCache[handle] = p; return p; });
    }
    function firstVariantId(p) {
      var vs = (p && p.variants) || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i].id;
      return vs[0] ? vs[0].id : '';
    }
    function favSlotHTML(productId, handle, variantId) {
      if (!variantId) return ''; // zonder variant vult Klaviyo de slot niet
      return '<div class="klaviyo-favorites-plp-slot" data-product-id="' + esc(productId) +
        '" data-product-url="/products/' + esc(handle) + '" data-variant-id="' + esc(variantId) + '"></div>';
    }

    // Detailweergave van één product: andere planten verbergen, alleen dit product
    // met beschrijving, variant/prijs, plantkenmerken + kalender. 'back' herstelt het resultaat.
    function showProductDetail(handle, back) {
      if (!handle) return;
      if (isModal) dialog.scrollTop = 0; else if (host.scrollIntoView) host.scrollIntoView({ behavior: 'smooth', block: 'start' });
      stageEl.innerHTML = '<button type="button" class="quiz__back quiz__pd-back">← Terug naar je tuinprofiel</button><p class="quiz__loading">Laden…</p>';
      stageEl.querySelector('.quiz__back').addEventListener('click', back);
      loadProduct(handle)
        .then(function (p) { renderDetail(p, handle, back); })
        .catch(function () { var l = stageEl.querySelector('.quiz__loading'); if (l) l.textContent = 'Product kon niet geladen worden.'; });
    }

    function renderDetail(p, handle, back) {
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var variants = p.variants || [];
      var titleLc = function (v) { return String(v && v.title || '').trim().toLowerCase(); };
      // Bundel/Los-product: toon standaard enkel de Los-variant en verberg de variant-keuze.
      var bundelLos = variants.some(function (v) { return titleLc(v) === 'los'; }) &&
                      variants.some(function (v) { return titleLc(v) === 'bundel'; });
      var sel = { variant: bundelLos
        ? (variants.filter(function (v) { return titleLc(v) === 'los'; })[0] || variants[0] || null)
        : (variants[0] || null) };
      var h = '<button type="button" class="quiz__back quiz__pd-back">← Terug naar je tuinprofiel</button>';
      h += '<div class="quiz__pd">';
      h += img ? '<div class="quiz__pd-imgwrap"><img class="quiz__pd-img" src="' + esc(img) + '" alt="' + esc(p.title) + '"><div class="quiz__pd-fav" data-pd-fav></div></div>' : '';
      h += '<h3 class="quiz__pd-title">' + esc(p.title) + '</h3>';
      h += '<p class="quiz__pd-price" data-pd-price></p>';
      if (!bundelLos && variants.length > 1) {
        h += '<div class="quiz__pv-variants">';
        variants.forEach(function (v, i) {
          h += '<button type="button" class="quiz__pv-variant' + (sel.variant === v ? ' is-active' : '') + '" data-vi="' + i + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
        });
        h += '</div>';
      }
      h += '<button type="button" class="quiz__pv-add btn btn--primary btn--solid">In winkelmand</button>';
      h += '<p class="quiz__pv-msg" role="status" aria-live="polite"></p>';
      if (p.description) h += '<div class="quiz__pd-desc rte">' + p.description + '</div>';
      h += '<div class="quiz__pd-extra" data-pd-extra></div>';
      h += '</div>';
      stageEl.innerHTML = h;
      stageEl.querySelector('.quiz__back').addEventListener('click', back);

      var priceEl = stageEl.querySelector('[data-pd-price]');
      var addBtn = stageEl.querySelector('.quiz__pv-add');
      var msg = stageEl.querySelector('.quiz__pv-msg');
      var favEl = stageEl.querySelector('[data-pd-fav]');
      var favVid = null;
      function mountFav() {
        if (!favEl) return;
        var vid = (sel.variant && sel.variant.id) || firstVariantId(p);
        if (vid === favVid) return; // slot al gemount voor deze variant
        favVid = vid;
        favEl.innerHTML = favSlotHTML(p.id, handle, vid);
      }
      function refresh() {
        priceEl.textContent = sel.variant ? money(sel.variant.price) : '';
        addBtn.disabled = !(sel.variant && sel.variant.available);
        addBtn.textContent = (sel.variant && sel.variant.available) ? 'In winkelmand' : 'Uitverkocht';
        addBtn.classList.remove('is-added');
        mountFav();
      }
      stageEl.querySelectorAll('.quiz__pv-variant').forEach(function (b) {
        b.addEventListener('click', function () {
          stageEl.querySelectorAll('.quiz__pv-variant').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          sel.variant = p.variants[parseInt(b.dataset.vi, 10)];
          refresh();
        });
      });
      addBtn.addEventListener('click', function () {
        if (!sel.variant) return;
        addBtn.disabled = true; msg.textContent = 'Toevoegen…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: sel.variant.id, quantity: 1, properties: { _quiz: slug } }) })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function () {
            addBtn.textContent = '✓ Toegevoegd'; addBtn.classList.add('is-added'); msg.textContent = '';
            ['theme:cart:refresh', 'cart:refresh', 'cart:build'].forEach(function (ev) { document.dispatchEvent(new CustomEvent(ev)); });
          })
          .catch(function () { addBtn.disabled = false; msg.textContent = 'Toevoegen mislukt. Probeer opnieuw.'; });
      });
      refresh();

      // Plantkenmerken + kalender via de Section Rendering API (uit de product-metafields).
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=quiz-product-extra')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (frag) { var ex = stageEl.querySelector('[data-pd-extra]'); if (ex) ex.innerHTML = frag; })
        .catch(function () { /* kenmerken/kalender optioneel */ });
    }
    var bar = host.querySelector('.quiz__progress-bar');
    var ptext = host.querySelector('.quiz__progress-text');

    function progress(done) {
      var total = questions.length;
      var pct = total ? (done / total * 100) : 0;
      if (bar) bar.style.width = pct + '%';
      var progEl = host.querySelector('.quiz__progress');
      if (progEl) {
        progEl.setAttribute('aria-valuemax', String(total || 1));
        progEl.setAttribute('aria-valuenow', String(done >= total ? total : done + 1));
      }
      if (ptext) {
        // Beervelde/filter_score: geen "JOUW RESULTAAT"-label op het resultaatscherm.
        if (done >= total && isFilterScore()) {
          ptext.textContent = '';
          ptext.hidden = true;
        } else if (done >= total) {
          ptext.hidden = false;
          ptext.textContent = pres.result_label || 'Jouw resultaat';
        } else {
          ptext.hidden = false;
          ptext.textContent = 'Vraag ' + (done + 1) + ' van ' + total;
        }
      }
    }

    // Chevron-SVG's (keuzehulp-concept): tegels + terug, live stroke-kleur via CSS
    var CHEV_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    var CHEV_LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>';

    function renderQuestion() {
      var q = questions[state.step];
      progress(state.step);
      var h = '<div class="quiz__question">';
      // Terug mét chevron boven de vraag (keuzehulp-stap-hiërarchie)
      if (state.step > 0) {
        h += '<button type="button" class="quiz__back">' + CHEV_LEFT + ' Vorige</button>';
      }
      h += '<h3 class="quiz__q-title">' + esc(q.title) + '</h3>';
      if (q.help) h += '<p class="quiz__q-help">' + esc(q.help) + '</p>';
      h += '<div class="quiz__options">';
      (q.answers || []).forEach(function (a, i) {
        h += '<button type="button" class="quiz__option" data-i="' + i + '">' + CHEV_RIGHT + '<span>' + esc(a.text) + '</span></button>';
      });
      h += '</div></div>';
      stageEl.innerHTML = h;
      stageEl.querySelectorAll('.quiz__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-pressed')) return;
          btn.classList.add('is-pressed');
          var idx = parseInt(btn.dataset.i, 10);
          setTimeout(function () { choose(q, idx); }, 140);
        });
      });
      var back = stageEl.querySelector('.quiz__back');
      if (back) back.addEventListener('click', goBack);
      var first = stageEl.querySelector('.quiz__option');
      if (first && first.focus) try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }

    function choose(q, idx) {
      var a = (q.answers || [])[idx];
      if (!a) return;
      var dim = dimFor(q.dimension);
      if (dim && dim.mode === 'direct') {
        state.direct[q.dimension] = a.outcome;
      } else {
        state.scores[q.dimension] = state.scores[q.dimension] || {};
        var s = state.scores[q.dimension];
        s[a.outcome] = (s[a.outcome] || 0) + (Number(a.points) || 0);
      }
      state.step += 1;
      if (state.step >= questions.length) finish(); else renderQuestion();
    }

    function goBack() {
      if (state.step === 0) return;
      state.step -= 1;
      var q = questions[state.step];
      var dim = dimFor(q.dimension);
      // Reset effect van de dimensie van de vraag waarnaar we terugkeren (veiligst: hele dimensie).
      if (dim && dim.mode === 'direct') delete state.direct[q.dimension];
      else state.scores[q.dimension] = {};
      renderQuestion();
    }

    function dimFor(key) {
      for (var i = 0; i < dims.length; i++) if (dims[i].key === key) return dims[i];
      return null;
    }

    function resolveDimension(dim) {
      if (dim.mode === 'direct') return state.direct[dim.key] || null;
      var s = state.scores[dim.key] || {};
      var max = -Infinity, leaders = [];
      Object.keys(s).forEach(function (k) { if (s[k] > max) { max = s[k]; leaders = [k]; } else if (s[k] === max) leaders.push(k); });
      if (leaders.length === 1) return leaders[0];
      // gelijkstand → tiebreak-uitkomst indien die meedingt, anders eerste
      if (dim.tiebreak && leaders.indexOf(dim.tiebreak) !== -1) return dim.tiebreak;
      return leaders[0] || (dim.tiebreak || null);
    }

    // ---- modus filter_score (WMS sept 2026; zelfde regels als keuzehulp / quiz-extra-engine) ----
    // Na resolveDimension: filter op role=filter (onbekend overslaan), score optellen op
    // role=score via package.scores, top_n tonen; relax_when_empty = meeste filter-treffers.
    var ONBEKEND_SLEUTELS = ['onbekend', 'weet-ik-niet', 'weet-het-niet', 'geen-idee', 'maakt-niet-uit'];

    function isFilterScore() {
      return (config.mode || 'combo') === 'filter_score';
    }

    function dimsWithRole(role) {
      return dims.filter(function (d) { return (d.role || 'uit') === role; });
    }

    function isUnknown(dim, key) {
      if (key == null || key === '') return true;
      if (dim && dim.unknown) return String(dim.unknown) === String(key);
      return ONBEKEND_SLEUTELS.indexOf(String(key)) !== -1;
    }

    // Pakket zonder props op een dimensie past overal (half ingevuld pakket niet stil laten verdwijnen).
    function matchesDim(pkg, dim, key) {
      var props = (pkg.props || {})[dim.key];
      if (!props || !props.length) return true;
      return props.indexOf(String(key)) !== -1;
    }

    function pointsOf(pkg, dimKey, key) {
      var s = (pkg.scores || {})[dimKey];
      if (!s || key == null) return 0;
      var n = Number(s[key]);
      return isFinite(n) ? n : 0;
    }

    function bestPackages(combo) {
      var packages = (config.packages || []).filter(function (p) { return p && (p.handle || p.title); });
      var matching = config.matching || {};
      var topN = Number(matching.top_n) || 3;
      var relax = matching.relax_when_empty !== false;

      var active = dimsWithRole('filter').filter(function (d) { return !isUnknown(d, combo[d.key]); });
      var scoreDims = dimsWithRole('score');

      var ranked = packages.map(function (pkg, i) {
        var miss = 0;
        active.forEach(function (d) { if (!matchesDim(pkg, d, combo[d.key])) miss++; });
        var score = 0;
        scoreDims.forEach(function (d) { score += pointsOf(pkg, d.key, combo[d.key]); });
        return { pkg: pkg, index: i, score: score, ok: miss === 0, hits: active.length - miss };
      });

      function byScore(a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      }

      var passed = ranked.filter(function (r) { return r.ok; }).sort(byScore);

      if (!passed.length && relax && ranked.length) {
        var best = -Infinity;
        ranked.forEach(function (r) { if (r.hits > best) best = r.hits; });
        passed = ranked.filter(function (r) { return r.hits === best; }).sort(byScore);
      }

      return passed.slice(0, topN).map(function (r) { return r.pkg; });
    }

    // Zelfde vorm als een config.results-rij, zodat renderResult / capture / favorieten gelijk blijven.
    function resultFromPackages(combo) {
      var pkgs = bestPackages(combo);
      var title = dimsWithRole('filter')
        .map(function (d) { return isUnknown(d, combo[d.key]) ? null : labelOf(d.key, combo[d.key]); })
        .filter(Boolean)
        .join(', ');
      return {
        title: title,
        body: [],
        items_mode: 'products',
        items: pkgs.map(function (p) {
          return { handle: p.handle, title: p.title, image: p.image, note: (p.body || []).join(' ') };
        })
      };
    }

    function finish() {
      var combo = {};
      dims.forEach(function (d) { combo[d.key] = resolveDimension(d); });
      var result = pickResult(combo);
      renderResult(combo, result);
      submit(slug, combo, result, source);
    }

    function pickResult(combo) {
      if (isFilterScore()) return resultFromPackages(combo);
      return matchResult(combo);
    }

    function matchResult(combo) {
      for (var i = 0; i < results.length; i++) {
        var c = results[i].combo || {};
        var ok = true;
        for (var k in c) if (c[k] !== combo[k]) { ok = false; break; }
        if (ok && Object.keys(c).length === Object.keys(combo).length) return results[i];
      }
      return null;
    }

    function labelOf(dimKey, outcomeKey) {
      var outs = config.outcomes || [];
      for (var i = 0; i < outs.length; i++) if (outs[i].dimension === dimKey && outs[i].key === outcomeKey) return outs[i].label;
      return outcomeKey;
    }

    function renderCaptureGate(combo, result) {
      progress(questions.length);
      if (ptext) {
        ptext.hidden = false;
        ptext.textContent = 'Laatste stap';
      }
      var nlLabel = pres.newsletter_label || 'Ja, hou me op de hoogte van nieuws en tuintips van Angelo.';
      var h = '<div class="quiz__capture quiz__capture--gate">' +
        '<h3 class="quiz__q-title">Vul je e-mail in om je resultaat te zien</h3>' +
        '<p class="quiz__q-help">Vink ook de nieuwsbrief aan. We sturen je resultaat daarna naar je mailbox.</p>' +
        '<form class="quiz__capture-form" novalidate>' +
        '<input type="email" class="quiz__email" placeholder="jouw@email.be" autocomplete="email" inputmode="email" value="' + esc(optEmail || customerEmail) + '" aria-label="E-mailadres" aria-required="true" required>' +
        '<label class="quiz__nl-label"><input type="checkbox" class="quiz__nl" aria-required="true"> ' + esc(nlLabel) + '</label>' +
        '<button type="submit" class="quiz__send btn btn--primary btn--solid">Toon mijn resultaat</button>' +
        '<p class="quiz__capture-msg" role="alert" aria-live="polite"></p></form></div>' +
        '<button type="button" class="quiz__restart btn btn--primary btn--solid">Test opnieuw doen</button>';
      stageEl.innerHTML = h;

      var restart = stageEl.querySelector('.quiz__restart');
      if (restart) restart.addEventListener('click', function () {
        state = { step: 0, scores: {}, direct: {} };
        capturedEmail = '';
        renderQuestion();
      });

      var form = stageEl.querySelector('.quiz__capture-form');
      var emailEl = form.querySelector('.quiz__email');
      var nlEl = form.querySelector('.quiz__nl');
      var msg = form.querySelector('.quiz__capture-msg');
      var nlLabelEl = nlEl.closest('.quiz__nl-label');

      emailEl.addEventListener('input', function () {
        if (isValidEmail(emailEl.value)) {
          emailEl.classList.remove('is-invalid');
          emailEl.removeAttribute('aria-invalid');
        }
      });
      nlEl.addEventListener('change', function () {
        if (nlEl.checked) nlLabelEl.classList.remove('is-invalid');
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        emailEl.classList.remove('is-invalid');
        emailEl.removeAttribute('aria-invalid');
        nlLabelEl.classList.remove('is-invalid');
        var val = (emailEl.value || '').trim();
        var emailOk = isValidEmail(val);
        var nlOk = !!nlEl.checked;
        if (!emailOk) {
          emailEl.classList.add('is-invalid');
          emailEl.setAttribute('aria-invalid', 'true');
        }
        if (!nlOk) nlLabelEl.classList.add('is-invalid');
        msg.classList.add('is-error');
        if (!emailOk && !nlOk) {
          msg.textContent = 'Vul een geldig e-mailadres in en vink de nieuwsbrief aan.';
          emailEl.focus();
          return;
        }
        if (!emailOk) {
          msg.textContent = 'Vul een geldig e-mailadres in.';
          emailEl.focus();
          return;
        }
        if (!nlOk) {
          msg.textContent = 'Vink de nieuwsbrief aan om je resultaat te zien.';
          nlEl.focus();
          return;
        }
        msg.classList.remove('is-error');
        var btn = form.querySelector('.quiz__send');
        btn.disabled = true;
        msg.textContent = 'Versturen…';
        sendCapture(slug, combo, result, val, true, source).then(function (ok) {
          if (ok) {
            capturedEmail = val;
            renderResult(combo, result);
          } else {
            btn.disabled = false;
            msg.classList.add('is-error');
            msg.textContent = 'Er ging iets mis. Probeer het straks opnieuw.';
          }
        });
      });

      try { emailEl.focus({ preventScroll: true }); } catch (err) { emailEl.focus(); }
    }

    function renderResult(combo, result) {
      if (gateResults && !capturedEmail) {
        renderCaptureGate(combo, result);
        return;
      }
      progress(questions.length);
      if (bar) bar.style.width = '100%';
      if (!result) { stageEl.innerHTML = '<p class="quiz__result-text">Bedankt voor het invullen van de test.</p>'; return; }
      var h = '<div class="quiz__result">';
      var rankedMode = isFilterScore();
      // filter_score: geen "JOUW RESULTAAT"-eyebrow en geen zon/vocht-titel (die zit in result.title).
      if (!rankedMode) {
        if (pres.result_eyebrow) h += '<p class="quiz__result-eyebrow">' + esc(pres.result_eyebrow) + '</p>';
        if (result.title) h += '<h3 class="quiz__result-title">' + esc(result.title) + '</h3>';
      }
      (result.body || []).forEach(function (p) { h += '<p class="quiz__result-text">' + esc(p) + '</p>'; });
      if ((result.items || []).length) {
        if (result.items_mode === 'products') {
          // Productkaarten worden async gevuld (alleen producten die nog op voorraad zijn).
          if (rankedMode) {
            // #1 apart; #2/#3 onder kop "Deze borderpakketten passen ook bij je tuin" (alleen als er secondary matches zijn).
            h += '<div class="quiz__pcards quiz__pcards--primary" data-pcards-primary data-ranked="1"></div>';
            h += '<div class="quiz__result-secondary" data-secondary hidden>' +
              '<h4 class="quiz__items-title">Deze borderpakketten passen ook bij je tuin</h4>' +
              '<div class="quiz__pcards quiz__pcards--ranked" data-pcards-secondary></div>' +
              '</div>';
          } else {
            if (pres.items_title) h += '<h4 class="quiz__items-title" data-items-title>' + esc(pres.items_title) + '</h4>';
            h += '<div class="quiz__pcards" data-pcards></div>';
          }
        } else {
          if (pres.items_title) h += '<h4 class="quiz__items-title">' + esc(pres.items_title) + '</h4>';
          h += '<ul class="quiz__items">';
          result.items.forEach(function (it) {
            h += '<li>' + (it.lat ? '<em>' + esc(it.lat) + '</em>' : '') + (it.nl ? ' – ' + esc(it.nl) : (it.lat ? '' : esc(it.label || ''))) + '</li>';
          });
          h += '</ul>';
        }
      }
      if (pres.disclaimer) h += '<p class="quiz__disclaimer">' + esc(pres.disclaimer) + '</p>';
      // Optionele promo (Beervelde e.d.): alleen copy/design, geen discount-code.
      // Aan via startInline({ showPromo: true }) of config.presentation.show_beervelde_promo.
      if (showPromo && isFilterScore()) {
        // Teksten komen uit de sectie-instellingen (data-promo-* op de host). Leeg veld = regel weg.
        var promo = readPromo(host);
        h += '<aside class="quiz__promo" aria-label="Kortingsactie">';
        if (promo.title) h += '<p class="quiz__promo-title">' + esc(promo.title) + '</p>';
        // Body is richtext uit de Shopify-customizer (vertrouwde merchant-HTML).
        if (promo.bodyHtml) h += '<div class="quiz__promo-body">' + promo.bodyHtml + '</div>';
        else if (promo.body) h += '<p class="quiz__promo-body">' + esc(promo.body) + '</p>';
        if (promo.period) h += '<p class="quiz__promo-sub">' + esc(promo.period) + '</p>';
        if (promo.btnLabel && promo.btnUrl) {
          h += '<a class="quiz__promo-cta btn btn--primary btn--solid" href="' + esc(promo.btnUrl) + '">' + esc(promo.btnLabel) + '</a>';
        }
        h += '</aside>';
      }
      // e-mailcapture. Bij gateResults is dit al gebeurd vóór het resultaat.
      if (gateResults && capturedEmail) {
        h += '<p class="quiz__capture-done">Gelukt. Je resultaat is onderweg naar ' + esc(capturedEmail) + '.</p>';
      } else if (!gateResults) {
        h += '<div class="quiz__capture"><h4 class="quiz__capture-title">' + esc(pres.capture_title || 'Stuur dit resultaat naar je mailbox') + '</h4>' +
          '<form class="quiz__capture-form" novalidate>' +
          '<input type="email" class="quiz__email" placeholder="jouw@email.be" autocomplete="email" value="' + esc(customerEmail) + '" aria-label="E-mailadres" required>' +
          '<label class="quiz__nl-label"><input type="checkbox" class="quiz__nl"> ' + esc(pres.newsletter_label || 'Ja, hou me op de hoogte van nieuws en tuintips van Angelo.') + '</label>' +
          '<button type="submit" class="quiz__send btn btn--primary btn--solid">' + esc(pres.capture_button || 'Stuur mij het resultaat') + '</button>' +
          '<p class="quiz__capture-msg" role="status" aria-live="polite"></p></form></div>';
      }
      h += '<button type="button" class="quiz__restart btn btn--primary btn--solid">Test opnieuw doen</button>';
      h += '</div>';
      stageEl.innerHTML = h;

      // Productkaarten async vullen: producten parallel laden, uitverkochte (available=false)
      // en niet-laadbare overslaan, en per kaart meteen het Klaviyo favorieten-hartje mounten.
      var pcardsEl = stageEl.querySelector('[data-pcards]');
      var primaryEl = stageEl.querySelector('[data-pcards-primary]');
      var secondaryEl = stageEl.querySelector('[data-pcards-secondary]');
      var secondaryWrap = stageEl.querySelector('[data-secondary]');
      var cardHosts = primaryEl || pcardsEl;
      if (cardHosts && result.items_mode === 'products') {
        var prodItems = (result.items || []).filter(function (it) { return it && it.handle; });
        Promise.all(prodItems.map(function (it) {
          return loadProduct(it.handle).then(function (p) { return { it: it, p: p }; }).catch(function () { return null; });
        })).then(function (rows) {
          var shown = 0;
          var ranked = !!(primaryEl || (pcardsEl && pcardsEl.getAttribute('data-ranked') === '1'));
          var secondaryCount = 0;
          rows.forEach(function (row) {
            if (!row || !row.p || !row.p.available) return; // uitverkocht of niet laadbaar → niet tonen
            var it = row.it, p = row.p;
            var raw = it.image || p.featured_image || '';
            var img = raw && raw.indexOf('//') === 0 ? 'https:' + raw : raw;
            var rank = shown + 1;
            var wrap = document.createElement('div');
            wrap.className = 'quiz__pcard-wrap' + (ranked && rank === 1 ? ' quiz__pcard-wrap--rank1' : '');
            var title = esc(it.title || p.title || it.handle);
            // Ranked filter_score: geen zon/vocht-achtige note onder de kaart (live look = collectiekaart).
            var note = (!ranked && it.note) ? '<span class="quiz__pcard-note">' + esc(it.note) + '</span>' : '';
            var imgHtml = img ? '<img src="' + esc(img) + '" alt="' + title + '" loading="lazy">' : '';
            var cardInner;
            if (ranked && rank === 1) {
              cardInner = imgHtml +
                '<span class="quiz__pcard-body">' +
                '<span class="quiz__pcard-badge">Beste match</span>' +
                '<span class="quiz__pcard-title">' + title + '</span>' +
                '</span>';
            } else if (ranked) {
              cardInner = '<span class="quiz__pcard-rank">#' + rank + '</span>' +
                imgHtml +
                '<span class="quiz__pcard-title">' + title + '</span>';
            } else {
              cardInner = imgHtml +
                '<span class="quiz__pcard-title">' + title + '</span>' +
                note;
            }
            wrap.innerHTML = '<button type="button" class="quiz__pcard' + (ranked && rank === 1 ? ' quiz__pcard--rank1' : '') + '" data-handle="' + esc(it.handle) + '">' +
              cardInner +
              '</button>' +
              '<div class="quiz__pcard-fav"></div>';
            var target = pcardsEl;
            if (ranked && primaryEl && secondaryEl) {
              if (rank === 1) target = primaryEl;
              else {
                target = secondaryEl;
                secondaryCount++;
              }
            }
            target.appendChild(wrap);
            wrap.querySelector('.quiz__pcard').addEventListener('click', function () {
              showProductDetail(it.handle, function () { renderResult(combo, result); });
            });
            wrap.querySelector('.quiz__pcard-fav').innerHTML = favSlotHTML(p.id, it.handle, firstVariantId(p));
            shown++;
          });
          if (ranked && secondaryWrap) {
            if (secondaryCount > 0) {
              secondaryWrap.hidden = false;
              if (secondaryEl && secondaryCount === 1) secondaryEl.classList.add('quiz__pcards--secondary-single');
            } else {
              secondaryWrap.hidden = true;
            }
          }
          if (shown === 0) {
            if (pcardsEl) pcardsEl.style.display = 'none';
            if (primaryEl) primaryEl.style.display = 'none';
            if (secondaryWrap) secondaryWrap.hidden = true;
            var t = stageEl.querySelector('[data-items-title]');
            if (t) t.style.display = 'none';
          }
        });
      }

      var restart = stageEl.querySelector('.quiz__restart');
      if (restart) restart.addEventListener('click', function () {
        state = { step: 0, scores: {}, direct: {} };
        capturedEmail = '';
        renderQuestion();
      });

      var form = stageEl.querySelector('.quiz__capture-form');
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = form.querySelector('.quiz__email');
        var nlEl = form.querySelector('.quiz__nl');
        var msg = form.querySelector('.quiz__capture-msg');
        var val = (emailEl.value || '').trim();
        if (!val || val.indexOf('@') < 1) { msg.textContent = 'Vul een geldig e-mailadres in.'; emailEl.focus(); return; }
        // Nieuwsbrief-opt-in is voorlopig verplicht: de resultaat-mail gaat via een
        // marketing-flow (nog niet als transactioneel gemarkeerd in Klaviyo), dus we
        // mogen enkel mailen naar wie zich abonneert.
        if (nlEl && !nlEl.checked) { msg.textContent = 'Vink aan dat je de nieuwsbrief wil ontvangen, dan kunnen we je het resultaat mailen.'; nlEl.focus(); return; }
        var btn = form.querySelector('.quiz__send');
        btn.disabled = true; msg.textContent = 'Versturen…';
        sendCapture(slug, combo, result, val, nlEl.checked, source).then(function (ok) {
          if (ok) form.innerHTML = '<p class="quiz__capture-done">Gelukt! Je resultaat is onderweg naar ' + esc(val) + '.</p>';
          else { btn.disabled = false; msg.textContent = 'Er ging iets mis. Probeer het straks opnieuw.'; }
        });
      });
    }

    // ---- submit (anoniem registreren) ----
    function submit(slug, combo, result, source) {
      if (!submitEndpoint) return;
      try {
        fetch(submitEndpoint, {
          method: 'POST', headers: authHeaders(), keepalive: true,
          body: JSON.stringify(payload(slug, combo, result, source, null, false))
        });
      } catch (e) { /* stil */ }
    }
    function sendCapture(slug, combo, result, email, newsletter, source) {
      if (!submitEndpoint) return Promise.resolve(false);
      return fetch(submitEndpoint, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify(payload(slug, combo, result, source, email, !!newsletter, true))
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }
    // Bouwt de payload. Voor backward-compat met de tuinprofiel garden-profile Edge
    // Function: dimensie 0 -> light, dimensie 1 -> soil (labels). 'quiz' + outcomes
    // gaan ook mee voor toekomstig generiek gebruik.
    function payload(slug, combo, result, source, email, newsletter, isKlaviyo) {
      var outcomes = {};
      dims.forEach(function (d) { outcomes[d.key] = { key: combo[d.key], label: labelOf(d.key, combo[d.key]) }; });
      var p = { quiz: slug, source: source, outcomes: outcomes };
      if (dims[0]) p.light = labelOf(dims[0].key, combo[dims[0].key]);
      if (dims[1]) p.soil = labelOf(dims[1].key, combo[dims[1].key]);
      // scores van de eerste score-dimensie (voor de Notion-analyse)
      for (var si = 0; si < dims.length; si++) {
        if (dims[si].mode === 'score') { p.scores = state.scores[dims[si].key] || {}; break; }
      }
      // Ingelogde context (pagina "Jouw Tuinprofiel"): koppel het profiel aan de klant
      // zodat het bij een volgend bezoek teruggevonden wordt.
      if (optLoggedIn) {
        p.logged_in = true;
        if (optEmail) p.email = optEmail;
      }
      if (isKlaviyo) {
        p.action = 'klaviyo';
        p.email = email;
        p.newsletter = newsletter;
        p.profile = (result && result.title) || '';
        p.profieltekst = (result && result.body) || [];
        p.planten = (result && result.items) || [];
      }
      return p;
    }

    if (opts.directResult) {
      var dCombo = opts.directResult;
      renderResult(dCombo, pickResult(dCombo));
    } else {
      renderQuestion();
    }
    if (isModal) open();
  }

  function bindTriggers() {
    if (triggersBound) return;
    triggersBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quiz], [data-tp-open]');
      if (!btn) return;
      e.preventDefault();
      if (!getModal()) return;
      // data-quiz heeft voorrang; data-tp-open is backward-compat (oude tuinprofiel-knoppen).
      var slug = btn.getAttribute('data-quiz') || 'tuinprofiel';
      var src = btn.getAttribute('data-quiz-source') || btn.getAttribute('data-tp-source') || 'page';
      runQuiz(slug, src, { gateResults: btn.getAttribute('data-quiz-gate') === 'true' });
    });
  }

  // ---- Publieke API voor inline gebruik (pagina "Jouw Tuinprofiel") ----
  // Endpoints/anon-key worden uit de inline-host (data-attributen) gelezen, zodat
  // de quiz ook werkt op pagina's zonder de globale .quiz-modal.
  function setEndpointsFrom(el) {
    if (!el) return;
    if (el.dataset.configEndpoint) configEndpoint = el.dataset.configEndpoint;
    if (el.dataset.submitEndpoint) submitEndpoint = el.dataset.submitEndpoint;
    if (el.dataset.key) anonKey = el.dataset.key;
    if (el.dataset.email) customerEmail = el.dataset.email;
  }

  // Map profiel-labels (bv. "Schaduw"/"Kleigrond") naar outcome-keys per dimensie.
  function labelsToCombo(config, light, soil) {
    var dims = config.dimensions || [];
    var outs = config.outcomes || [];
    var want = {};
    if (dims[0]) want[dims[0].key] = light;
    if (dims[1]) want[dims[1].key] = soil;
    var combo = {};
    dims.forEach(function (d) {
      var label = want[d.key];
      var m = outs.filter(function (o) {
        return o.dimension === d.key && String(o.label).toLowerCase() === String(label || '').toLowerCase();
      })[0];
      combo[d.key] = m ? m.key : null;
    });
    return combo;
  }

  window.AngeloQuiz = {
    // Start de test inline in een container (geen modal). opts: { email, loggedIn, source, showPromo }
    startInline: function (host, slug, o) {
      o = o || {};
      injectCSS();
      setEndpointsFrom(host);
      host.innerHTML = '<p class="quiz__loading">Even laden…</p>';
      return loadConfig(slug).then(function (d) {
        startQuiz(slug, d.config || {}, o.source || 'inline', { host: host, modal: false, email: o.email, loggedIn: o.loggedIn, showPromo: !!o.showPromo, gateResults: !!o.gateResults });
      }).catch(function () { host.innerHTML = '<p class="quiz__loading">De test kon niet geladen worden. Probeer het later opnieuw.</p>'; });
    },
    // Toon direct het resultaat voor een bekend profiel (light/soil labels). opts: { email, loggedIn, source }
    showResult: function (host, slug, o) {
      o = o || {};
      injectCSS();
      setEndpointsFrom(host);
      host.innerHTML = '<p class="quiz__loading">Je tuinprofiel laden…</p>';
      return loadConfig(slug).then(function (d) {
        var config = d.config || {};
        startQuiz(slug, config, o.source || 'inline', { host: host, modal: false, email: o.email, loggedIn: o.loggedIn, directResult: labelsToCombo(config, o.light, o.soil) });
      }).catch(function () { host.innerHTML = '<p class="quiz__loading">Je tuinprofiel kon niet geladen worden. Probeer het later opnieuw.</p>'; });
    }
  };

  function init() {
    if (!document.querySelector('.quiz-modal')) return;
    injectCSS();
    getModal();
    bindTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
